import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let SBProMenuJoinus = class SBProMenuJoinus extends Vue {
};
SBProMenuJoinus = __decorate([
    Component({})
], SBProMenuJoinus);
export default SBProMenuJoinus;
